import { CheckSquare, Square } from "lucide-react";
import { FadeUp } from "./Reveal";

export function EstimateCard() {
  return (
    <div className="bg-white text-navy p-6 shadow-2xl relative rotate-[-1.5deg]" data-testid="artifact-estimate">
      <div className="flex justify-between items-start border-b-2 border-navy pb-3 mb-4">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Estimate</p>
          <p className="font-display font-extrabold text-xl">EST-0142</p>
        </div>
        <p className="font-mono text-[10px] text-slate-500 text-right">VALID 14 DAYS<br />SENT IN 47 MIN</p>
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between"><span>Exterior wash — 2,400 sq ft</span><span className="font-mono">$380</span></div>
        <div className="flex justify-between"><span>Driveway + walkways</span><span className="font-mono">$160</span></div>
        <div className="flex justify-between"><span>Gutter faces</span><span className="font-mono">$90</span></div>
      </div>
      <div className="flex justify-between border-t border-slate-300 mt-4 pt-3 font-display font-extrabold text-lg">
        <span>Total</span><span className="text-safety">$630</span>
      </div>
      <div className="barcode h-8 w-40 text-navy mt-4 opacity-70" />
    </div>
  );
}

export function InvoiceCard() {
  return (
    <div className="bg-navy text-white p-6 shadow-2xl relative rotate-[1.2deg] border border-white/10" data-testid="artifact-invoice">
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">Invoice</p>
          <p className="font-display font-extrabold text-xl">INV-0388</p>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-widest bg-emerald-500/15 text-emerald-400 border border-emerald-500/40 px-2 py-1">Paid</span>
      </div>
      <div className="space-y-2 text-sm text-slate-300">
        <div className="flex justify-between"><span>Weekly service — 4 visits</span><span className="font-mono text-white">$520</span></div>
        <div className="flex justify-between"><span>Sent</span><span className="font-mono">4:12 PM — job done</span></div>
        <div className="flex justify-between"><span>Paid</span><span className="font-mono">6:03 PM — card</span></div>
      </div>
      <div className="perforation h-3 -mx-6 mt-5" />
      <p className="font-mono text-[10px] text-slate-500 mt-2 uppercase tracking-[0.2em]">1 hr 51 min — job to cash</p>
    </div>
  );
}

export function ChecklistCard() {
  const items = [
    { label: "Confirm tomorrow's jobs", done: true },
    { label: "Send 2 open estimates", done: true },
    { label: "Invoice today's completions", done: true },
    { label: "Review request — Martinez job", done: false },
  ];
  return (
    <div className="bg-white text-navy p-6 shadow-2xl rotate-[2deg]" data-testid="artifact-checklist">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">End-of-day routine</p>
      <p className="font-display font-extrabold text-lg mb-4">Friday // 16:45</p>
      <div className="space-y-2.5">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-2.5 text-sm">
            {it.done ? <CheckSquare size={16} className="text-safety" /> : <Square size={16} className="text-slate-400" />}
            <span className={it.done ? "line-through text-slate-400" : ""}>{it.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ArtifactShowcase() {
  return (
    <div className="grid md:grid-cols-3 gap-8 md:gap-6 items-start">
      <FadeUp delay={0}><EstimateCard /></FadeUp>
      <FadeUp delay={0.15} className="md:mt-12"><InvoiceCard /></FadeUp>
      <FadeUp delay={0.3} className="md:mt-24"><ChecklistCard /></FadeUp>
    </div>
  );
}
